/**
 * Floating AI Assistant Button
 * Provides global access to ChiefOfStaff AI on all authenticated pages
 */

import { useState } from 'react';
import { Sparkles } from 'lucide-react';
import { ChiefOfStaffChat } from './ChiefOfStaffChat';

export function FloatingAIAssistant() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* Floating Action Button */}
      {!isOpen && (
        <button
          onClick={() => setIsOpen(true)}
          className="fixed bottom-6 right-6 z-40 w-16 h-16 bg-gradient-to-br from-purple-600 to-blue-600 text-white rounded-full shadow-2xl hover:shadow-purple-500/50 hover:scale-110 transition-all duration-300 flex items-center justify-center group"
          aria-label="Open AI Assistant"
        >
          <Sparkles className="w-8 h-8 group-hover:rotate-12 transition-transform" />
          <span className="absolute -top-1 -right-1 w-4 h-4 bg-green-500 rounded-full border-2 border-white animate-pulse"></span>
        </button>
      )}

      {/* Chat Interface */}
      {isOpen && (
        <div className="fixed bottom-6 right-6 z-50 w-full max-w-2xl h-[600px] md:h-[700px]">
          <div className="relative w-full h-full">
            <ChiefOfStaffChat
              onClose={() => setIsOpen(false)}
              fullScreen={false}
            />
          </div>
        </div>
      )}

      {/* Mobile Overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/20 z-40 md:hidden"
          onClick={() => setIsOpen(false)}
        />
      )}
    </>
  );
}
